<ng-container [ngSwitch]="sliderType">
    <ng-container *ngSwitchCase="'range'">
        <ngx-slider
            [value]="value"
            [highValue]="highValue"
            [options]="options"
            (valueChange)="change($event)"
            (highValueChange)="highValueChange($event)"
        ></ngx-slider>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <ngx-slider [value]="value" [options]="options" (userChange)="change($event)"></ngx-slider>
    </ng-container>
</ng-container>
